import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import i18n from "i18next";

import { FeedbackPopup } from "../Layout/FeedbackPopup";
import { Panel, PanelHeader } from "../Layout/Panel";
import { getIsLoadingSelector } from "../../selectors/selectors";
import { getUserName } from "../../helpers/userHelpers";
import { setPublishSucceeded, updateNotification } from "../../actions";
import NotificationForm from "./NotificationForm";

class EditNotificationPage extends PureComponent {
  static propTypes = {
    setPublishSucceeded: PropTypes.func.isRequired,
    updateNotification: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    isMobile: PropTypes.bool,
    notification: PropTypes.object,
    publishSucceeded: PropTypes.bool,
    sender: PropTypes.string,
    transition: PropTypes.object
  };

  static defaultProps = {
    sender: "",
    isLoading: false,
    isMobile: false,
    notification: {},
    publishSucceeded: false,
    transition: {}
  };

  componentDidUpdate(prevProps) {
    if (this.props.publishSucceeded && !prevProps.publishSucceeded) {
      setTimeout(this.handleRedirect, 1450);
    }
  }

  handleRedirect = () => {
    this.props.setPublishSucceeded(false);
    this.props.transition.router.stateService.go("manage-notifications");
  };

  handleSubmitNotification = values => {
    const { sender, notification } = this.props;
    const { id, created, expired } = notification;
    this.props.updateNotification({ ...values, created, expired, sender, id });
  };

  render() {
    const { isLoading, isMobile, notification, publishSucceeded } = this.props;

    return (
      <Panel className="notification__panel">
        <PanelHeader id={i18n.t("notification.edit")} isMobile={isMobile} />
        <NotificationForm
          initialValues={notification}
          onSubmit={this.handleSubmitNotification}
          isDisabled={isLoading || publishSucceeded}
          isInEditMode
        />
        {publishSucceeded && <FeedbackPopup />}
      </Panel>
    );
  }
}

const mapStateToProps = state => {
  return {
    isLoading: getIsLoadingSelector(state, [updateNotification.id]),
    isMobile: state.app.isMobile,
    notification: state.notifications.notificationsById[state.app.routerParams.notificationId],
    publishSucceeded: state.notifications.publishSucceeded,
    sender: getUserName(state.app.user)
  };
};

export default connect(
  mapStateToProps,
  { updateNotification, setPublishSucceeded }
)(EditNotificationPage);



// WEBPACK FOOTER //
// ./src/components/Notifications/EditNotificationPage.js